import { Box, Button, Checkbox, Collapse, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Paper, Popover, Radio, RadioGroup, Stack, Switch, Tab, Tabs, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Container from 'src/components/container/Container'
import CustomInput from 'src/components/customerinput/CustomerInput';
import { useSettingsContext } from 'src/components/settings';
import { useMobileCode } from 'src/hooks/useMobileCode';
import validCountryDataList from 'src/utils/countryCodeAndName';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { notify } from 'src/components/notify';
import createStaff from 'src/services/staffs/createStaff';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useLocation, useNavigate } from 'react-router';
import getFeatures from 'src/services/staffs/getFeatures';
import createStaffFeature from 'src/services/staffs/createStaffFeature';
import { useSearchParams } from 'react-router-dom';
import getMenusByStaff from 'src/services/staffs/getMenus';
import createStaffMenus from 'src/services/staffs/createStaffMenus';
import { LoadingButton } from '@mui/lab';
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CreateUser() {
    const { themeStretch } = useSettingsContext();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const location = useLocation()
    const [value, setValue] = useState(0);
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };
    const { user, logout } = useAuthContext()
    const { code, setCode, phoneNumberLength, setPhoneNumberLength, anchorEl, searchText, setSearchText, handleSearchTextChange, filteredMenuItems, handleCountryCode, handleMenuClose, handleCode } = useMobileCode()
    const [values, setValues] = useState({ mobile: "", name: "", email: "", password: "", employee_status: "actives" })
    const handleChange = (e) => {
        const { name, value } = e.target
        setValues((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }
    const [features, setFeatures] = useState([])
    const handleSubmit = async () => {
        try {

            if (!values.name.trim()) {
                return notify("Name is required.")
            }
            if (!values.mobile.trim()) {
                return notify("Mobile number is required.")
            }
            if (phoneNumberLength != values.mobile.length) {
                notify(`Mobile number should be ${phoneNumberLength} digits long`);
                return
            }
            if (!values.email.trim()) {
                return notify("Email is required.")
            }
            if (!location.state) {
                if (!values.password.trim()) {
                    return notify("Password is required.")
                }
            }
            let url = location.state ? `/system/admin/update/${values?._id}` : "/system/admin/create"
            let method = location.state ? "put" : "post"
            let newData = { ...values, country_code: code, password: values?.password || undefined }
            if (location.state) {
                newData = {
                    partner: { ...values, country_code: code, password: values?.password || undefined },
                }
            }
            setLoading(true)
            const data = await createStaff(user, url, method, newData, logout)
            if (data) {
                notify("Create Successfully.", "success")
                setValue(1)
                setValues((prev) => {
                    return {
                        ...prev,
                        _id: data?.data?._payload?.partner?._id
                    }
                })
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoading(false)
        }
    }
    const handleSubmitFeature = async () => {
        try {
            if (!values?._id) {
                return notify("Partner id is required.")
            }
            setLoading(true)
            const data = await createStaffFeature(user, { capabilities: features.flatMap((it) => it.features) }, logout, values?._id)
            if (data) {
                notify("Create Successfully.", "success")
                setValue(2)

            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoading(false)
        }
    }
    const handleSubmitMenus = async () => {
        try {
            if (!values?._id) {
                return notify("Partner id is required.")
            }
            setLoading(true)
            const data = await createStaffMenus(user, { menues: menus.filter(({ check }) => check).map((it) => it.id) }, logout, values?._id)
            if (data) {
                console.log(data);
                notify("Create Successfully.", "success")
                navigate(-1)


            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        if (location.state) {
            const { partner, employee_status } = location.state
            setValues({
                mobile: partner?.mobile || "", name: partner?.name || "", email: partner.email || "", password: "", _id: partner?._id || undefined, employee_status: employee_status || "active"
            })
        }
    }, [])
    console.log(values);



    useEffect(() => {
        const fetchData = async () => {
            const response = await getFeatures(user, logout, values?._id)
            if (response) {
                setFeatures(() => {
                    const grouped = response?.data?.features?.reduce((acc, it) => {
                        const serviceName = it?.service?.name || "Other";

                        if (!acc[serviceName]) {
                            acc[serviceName] = {
                                service: serviceName,
                                features: []
                            };
                        }

                        const data = response?.data?.payload?.find(
                            (ite) => ite.feature._id === it._id
                        );

                        acc[serviceName].features.push({
                            feature: it._id,
                            feature_name: it.name,
                            can_read: data?.can_read || false,
                            can_create: data?.can_create || false,
                            can_update: data?.can_update || false,
                            can_delete: data?.can_delete || false,
                        });

                        return acc;
                    }, {});

                    return Object.values(grouped);
                });
            }
        }
        if (value == 1 && values?._id) {
            fetchData()
        }
    }, [value, values?._id])
    // console.log(features.flatMap((it) => it.features), "lllllllllllllllllllllll");


    const [menus, setMenus] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const response = await getMenusByStaff(user, logout, values?._id)
            setMenus((prev) => {
                return response?.data?.menues?.map((it) => {
                    const check = response?.data?.payload.find((ite) => ite.menu._id == it._id && ite?.status)
                    return {
                        name: it?.label,
                        id: it?._id,
                        check: check ? true : false
                    }
                })

            })

        }
        if (value == 2 && values?._id) {
            fetchData()
        }
    }, [value])

    // const handleChangeCheck = (index, key, checked) => {
    //     if (key == "all") {
    //         setFeatures((prev) => {
    //             let update = [...prev]
    //             update[index]["can_read"] = checked
    //             update[index]["can_create"] = checked
    //             update[index]["can_update"] = checked
    //             update[index]["can_delete"] = checked
    //             return update
    //         })
    //     } else {
    //         setFeatures((prev) => {
    //             let update = [...prev]
    //             update[index][key] = checked
    //             return update
    //         })
    //     }
    // }
    const handleChangeCheck = (serviceIndex, featureIndex, key, checked) => {
        setFeatures((prev) => {
            let update = [...prev]; // copy services

            if (key === "all") {
                // toggle all permissions in one feature
                update[serviceIndex].features[featureIndex] = {
                    ...update[serviceIndex].features[featureIndex],
                    can_read: checked,
                    can_create: checked,
                    can_update: checked,
                    can_delete: checked,
                };
            } else {
                // toggle single permission
                update[serviceIndex].features[featureIndex] = {
                    ...update[serviceIndex].features[featureIndex],
                    [key]: checked,
                };
            }

            return update;
        });
    };

    const handleChangeMenuCheck = (index, key, checked) => {
        if (key == "all") {
            setMenus((prev) => {
                let update = [...prev]
                update = update.map((it) => {
                    return {
                        ...it,
                        check: checked
                    }
                })
                return update
            })
        } else {
            setMenus((prev) => {
                let update = [...prev]
                update[index]["check"] = checked
                return update
            })
        }
    }
    const [openServices, setOpenServices] = useState({});
    const toggleService = (index) => {
        setOpenServices((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };
    const handleServiceSelectAll = (serviceIndex, checked) => {
        setFeatures((prev) => {
            let update = [...prev];

            update[serviceIndex].features = update[serviceIndex].features.map((f) => ({
                ...f,
                can_read: checked,
                can_create: checked,
                can_update: checked,
                can_delete: checked,
            }));

            return update;
        });
    };

    const handleGlobalSelectAll = (checked) => {
        setFeatures((prev) =>
            prev.map((service) => ({
                ...service,
                features: service.features.map((f) => ({
                    ...f,
                    can_read: checked,
                    can_create: checked,
                    can_update: checked,
                    can_delete: checked,
                })),
            }))
        );
    };
    const [allExpanded, setAllExpanded] = useState(false);
    const handleGlobalExpandCollapse = () => {
        const expand = !allExpanded; // toggle state
        const updated = {};
        features.forEach((_, index) => {
            updated[index] = expand;
        });
        setOpenServices(updated);
        setAllExpanded(expand);
    };

    const totalFeatures = features?.reduce((sum, g) => sum + g.features.length, 0);
    const selectedCount = features?.reduce(
        (sum, g) =>
            sum +
            g.features.filter(
                (f) => f.can_read && f.can_create && f.can_update && f.can_delete
            ).length,
        0
    );
    return (
        <div>
            <Container maxWidth={themeStretch ? false : 'lg'}>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', mb: 2 }}
                    alignContent="center"
                >
                    <Typography variant="h4" color="primary" >
                        Create Staff
                    </Typography>
                </Stack>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
                        <Tab label="Create Staff" {...a11yProps(0)} />
                        <Tab label="Features" {...a11yProps(1)} />
                        <Tab label="Menus" {...a11yProps(2)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} lg={7}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <CustomInput
                                        label="Phone"
                                        input={
                                            <Grid container spacing={1}>
                                                <Grid item xs={3} md={2}>
                                                    <FormControl sx={{ p: 0 }}>
                                                        <TextField
                                                            size="small"
                                                            variant="outlined"
                                                            placeholder="91"
                                                            disabled={location.state}
                                                            sx={{
                                                                maxWidth: "7.4rem",
                                                                p: 0,
                                                            }}
                                                            value={
                                                                code?.includes("+") ? code?.slice(1) : code
                                                            }
                                                            name="mobile"
                                                            onChange={handleCode}
                                                            inputProps={{
                                                                maxLength: 3,
                                                                inputMode: "numeric",
                                                                pattern: "[0-9]*",
                                                                style: {
                                                                    padding: "0px",
                                                                    fontSize: "0.8rem",
                                                                    minHeight: "55px",
                                                                    textAlign: "center",
                                                                },
                                                                onInput: (e) => {
                                                                    e.target.value = e.target.value.replace(
                                                                        /[^0-9]/g,
                                                                        ""
                                                                    );
                                                                },
                                                            }}
                                                            required
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <IconButton
                                                                        sx={{ p: 0, cursor: "pointer" }}
                                                                        disabled={location.state}
                                                                        onClick={handleCountryCode}
                                                                    >
                                                                        <ArrowDropDownIcon />
                                                                    </IconButton>
                                                                ),
                                                                startAdornment: (
                                                                    <Typography variant="h5" sx={{ p: 0, pl: "10px" }}>
                                                                        +
                                                                    </Typography>
                                                                ),
                                                            }}
                                                        />
                                                        <Popover
                                                            open={Boolean(anchorEl)}
                                                            anchorEl={anchorEl}
                                                            onClose={handleMenuClose}
                                                            sx={{
                                                                mt: 3,
                                                                maxHeight: 270,
                                                            }}
                                                            anchorOrigin={{
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            }}
                                                        >
                                                            <TextField
                                                                variant="outlined"
                                                                placeholder="Search"
                                                                fullWidth
                                                                size="small"
                                                                sx={{
                                                                    p: 1,
                                                                    position: "-webkit-sticky",
                                                                    top: 0,
                                                                    zIndex: 1000,
                                                                    backgroundColor: "#FFFFFF",
                                                                }}
                                                                onChange={handleSearchTextChange}
                                                            />
                                                            {searchText == ""
                                                                ? validCountryDataList?.map((item) => (
                                                                    <MenuItem
                                                                        key={item?.name}
                                                                        sx={{ pt: 2 }}
                                                                        value={item.code}
                                                                        onClick={() => {
                                                                            setCode(item?.code);
                                                                            setPhoneNumberLength(
                                                                                item?.phoneLength
                                                                            );
                                                                            handleMenuClose();
                                                                        }}
                                                                    >
                                                                        {item?.code} ({item?.name})
                                                                    </MenuItem>
                                                                ))
                                                                : filteredMenuItems?.map((item) => (
                                                                    <MenuItem
                                                                        key={item?.name}
                                                                        value={item.code}
                                                                        onClick={() => {
                                                                            setCode(item.code);
                                                                            handleMenuClose();
                                                                            setPhoneNumberLength(
                                                                                item?.phoneLength
                                                                            );
                                                                            setSearchText("");
                                                                        }}
                                                                    >
                                                                        {item?.code} ({item?.name})
                                                                    </MenuItem>
                                                                ))}
                                                        </Popover>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={9} md={10}>
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder={
                                                            phoneNumberLength
                                                                ? `Add ${phoneNumberLength} digit phone number`
                                                                : "Please select country code"
                                                        }
                                                        name="mobile"
                                                        disabled={location.state}
                                                        inputProps={{
                                                            inputMode: "numeric",
                                                            pattern: "[0-9]*",

                                                            maxLength: parseInt(phoneNumberLength),
                                                            onInput: (e) => {
                                                                e.target.value = e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    ""
                                                                );
                                                            },
                                                        }}
                                                        fullWidth
                                                        value={values?.mobile?.trim()}
                                                        onChange={handleChange}
                                                    />
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomInput label="Name" input={<TextField fullWidth placeholder="Enter name"
                                        name='name'
                                        value={values?.name?.trim()}
                                        onChange={handleChange}
                                    />} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomInput label="Email" input={<TextField fullWidth placeholder="Enter email"
                                        name='email'
                                        value={values?.email?.trim()}
                                        onChange={handleChange}
                                    />} />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput label="Password" input={<TextField fullWidth placeholder="Enter password"
                                        name='password'
                                        value={values?.password?.trim()}
                                        onChange={handleChange}
                                    />} />
                                </Grid>
                                {location.state && <Grid item xs={12}>
                                    <CustomInput label="Status" input={
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name='employee_status'
                                            value={values?.employee_status || ""}
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel value="active" control={<Radio />} label="Active" />
                                            <FormControlLabel value="terminated" control={<Radio />} label="Terminate" />
                                        </RadioGroup>
                                    } />
                                </Grid>}
                                <Grid item xs={12}>
                                    <Stack direction="row" gap="10px" mt="20px">
                                        <LoadingButton loading={loading} disabled={loading} variant="contained" onClick={() => handleSubmit()}>
                                            Create Staff
                                        </LoadingButton>
                                        <Button variant="outlined" onClick={() => navigate(-1)}>
                                            Cancel
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <Typography variant="subtitle1" fontSize="20px">Features</Typography>
                    {/* <Stack spacing={2} mt={2}>
                        {
                            features?.map((it, index) => {
                                return (
                                    <Stack key={it.feature}>
                                        <Typography variant="body1">{it?.feature_name} ({it?.service})</Typography>
                                        <Stack direction="row" gap="20px">
                                            <FormControlLabel control={<Checkbox checked={it?.can_read && it?.can_create && it?.can_update && it?.can_delete} onChange={(e) => handleChangeCheck(index, "all", e.target.checked)} />} label="Select All" />
                                            <FormControlLabel control={<Checkbox checked={it?.can_read} onChange={(e) => handleChangeCheck(index, "can_read", e.target.checked)} />} label="Read" />
                                            <FormControlLabel control={<Checkbox checked={it?.can_create} onChange={(e) => handleChangeCheck(index, "can_create", e.target.checked)} />} label="Create" />
                                            <FormControlLabel control={<Checkbox checked={it?.can_update} onChange={(e) => handleChangeCheck(index, "can_update", e.target.checked)} />} label="Update" />
                                            <FormControlLabel control={<Checkbox checked={it?.can_delete} onChange={(e) => handleChangeCheck(index, "can_delete", e.target.checked)} />} label="Delete" />
                                        </Stack>
                                    </Stack>
                                )
                            })
                        }

                    </Stack> */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        {/* Enable/Disable All */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={selectedCount === totalFeatures && totalFeatures > 0}
                                    onChange={(e) => handleGlobalSelectAll(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label={
                                selectedCount === totalFeatures
                                    ? `Disable All Features (${selectedCount}/${totalFeatures})`
                                    : `Enable All Features (${selectedCount}/${totalFeatures})`
                            }
                        />

                        {/* Expand / Collapse All */}
                        <Stack direction="row" gap={2}>
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={handleGlobalExpandCollapse}
                            >
                                {allExpanded ? "Collapse All" : "Expand All"}
                            </Button>

                        </Stack>
                    </Stack>

                    <Stack spacing={3} mt={2}>
                        {features?.map((serviceGroup, serviceIndex) => {
                            const isOpen = openServices[serviceIndex] ?? false; // default open
                            const totalFeatures = serviceGroup.features.length;
                            const selectedCount = serviceGroup.features.filter(
                                (f) => f.can_read && f.can_create && f.can_update && f.can_delete
                            ).length;

                            return (
                                <Paper key={serviceGroup.service} sx={{ padding: "15px" }}>
                                    <Stack spacing={2}>
                                        {/* Header with toggle */}
                                        <Stack direction="row" justifyContent="space-between" sx={{ cursor: "pointer", borderBottom: 1, borderColor: "divider", pb: 1 }} alignItems="center" onClick={() => toggleService(serviceIndex)}>
                                            <Typography variant="h6">
                                                {serviceIndex + 1}) {serviceGroup.service}
                                            </Typography>
                                            <Stack direction="row" gap={2}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={selectedCount === totalFeatures}
                                                            onChange={(e) =>
                                                                handleServiceSelectAll(serviceIndex, e.target.checked)
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    onClick={(e) => e.stopPropagation()}
                                                    label={
                                                        selectedCount === totalFeatures
                                                            ? `Disable All (${selectedCount}/${totalFeatures})`
                                                            : `Enable All (${selectedCount}/${totalFeatures})`
                                                    }
                                                />

                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={(e) => { e.stopPropagation(); toggleService(serviceIndex) }}
                                                >
                                                    {isOpen ? "Collapse" : "Expand"}
                                                </Button>
                                            </Stack>
                                        </Stack>

                                        {/* Collapsible content */}
                                        <Collapse in={isOpen}>
                                            <Stack spacing={2} mt={1}>
                                                {serviceGroup.features.map((feat, featIndex) => (
                                                    <Stack key={feat.feature_id}>
                                                        <Typography variant="body1">
                                                            {featIndex + 1}) {feat.feature_name}
                                                        </Typography>

                                                        <Stack direction="row" gap="20px">
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={
                                                                            feat.can_read &&
                                                                            feat.can_create &&
                                                                            feat.can_update &&
                                                                            feat.can_delete
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleChangeCheck(
                                                                                serviceIndex,
                                                                                featIndex,
                                                                                "all",
                                                                                e.target.checked
                                                                            )
                                                                        }

                                                                    />
                                                                }
                                                                label="Select All"
                                                            />

                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={feat.can_read}
                                                                        onChange={(e) =>
                                                                            handleChangeCheck(
                                                                                serviceIndex,
                                                                                featIndex,
                                                                                "can_read",
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                }
                                                                label="Read"
                                                            />

                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={feat.can_create}
                                                                        onChange={(e) =>
                                                                            handleChangeCheck(
                                                                                serviceIndex,
                                                                                featIndex,
                                                                                "can_create",
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                }
                                                                label="Create"
                                                            />

                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={feat.can_update}
                                                                        onChange={(e) =>
                                                                            handleChangeCheck(
                                                                                serviceIndex,
                                                                                featIndex,
                                                                                "can_update",
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                }
                                                                label="Update"
                                                            />

                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={feat.can_delete}
                                                                        onChange={(e) =>
                                                                            handleChangeCheck(
                                                                                serviceIndex,
                                                                                featIndex,
                                                                                "can_delete",
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                }
                                                                label="Delete"
                                                            />
                                                        </Stack>
                                                    </Stack>
                                                ))}
                                            </Stack>
                                        </Collapse>
                                    </Stack>
                                </Paper>
                            );
                        })}
                    </Stack>





                    <Stack mt={4} direction="row" gap="10px">
                        <LoadingButton loading={loading} disabled={loading} variant="contained" onClick={handleSubmitFeature}>Create</LoadingButton>
                        <Button>Cancel</Button>

                    </Stack>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <Typography variant="subtitle1" fontSize="20px">Menus</Typography>
                    <Stack spacing={2} mt={2}>
                        <Stack >
                            <Stack direction="row" gap="20px">
                                <FormControlLabel control={<Checkbox checked={menus?.filter((it) => it.check).length == menus?.length} onChange={(e) => handleChangeMenuCheck(0, "all", e.target.checked)} />} label={"Select All"} />
                            </Stack>
                        </Stack>
                        {
                            menus?.map((it, index) => {
                                return (
                                    <Stack key={it._id}>
                                        <Stack direction="row" gap="20px">
                                            <FormControlLabel control={<Checkbox checked={it?.check} onChange={(e) => handleChangeMenuCheck(index, "check", e.target.checked)} />} label={it?.name} />
                                        </Stack>
                                    </Stack>
                                )
                            })
                        }

                    </Stack>
                    <Stack mt={4} direction="row" gap="10px">
                        <LoadingButton loading={loading} disabled={loading} variant="contained" onClick={handleSubmitMenus}>Create</LoadingButton>
                        <Button variant="outlined" onClick={() => navigate(-1)}>Cancel</Button>
                    </Stack>
                </CustomTabPanel>


            </Container>
        </div>
    )
}
